import { SummaryModel } from "src/app/modules/common/entity/summary.model";
import {Moment} from "moment";
import {UserSummary} from "../../../../../account/modules/user/api/entity/userSummary.model";
import {PermissionsModel} from "../../../../../common/entity/permissions.model";

export class MedicalSterilizationSummaryModel implements SummaryModel {
  id: number;
  permissions: PermissionsModel;
  sterilizationDate: Moment;
  validationDate: Moment;
  responsibleUser: UserSummary;
}

